import { connect } from 'react-redux';
import StatsDataGrid from '../../components/DataGrid/StatsDataGrid';



const mapStateToProps = state => {
    return {
        rowFilter: state.rowFilters
    }
};

export default connect(
    mapStateToProps,
)(StatsDataGrid);


// WEBPACK FOOTER //
// ./src/containers/DataGrid/StatsDataGridContainer.js